<div class="search-container-details stats-border-radius">
    <div class="table-title-container">
        <span class="table-title">{{ title }}</span>
        <span class="table-sub-title">{{ subTitle }}</span>
    </div>
    <div class="inbox-search-container">
        <cll-form-field label="Type a keyword...">
            <cll-icon cllPrefix>search</cll-icon>
            <input [formControl]="searchControl"
                   cllFormInput
                   type="text">

            @if (searchControl.value) {
                <button (click)="searchControl.reset()"
                        cll-icon-button
                        cllTooltip="Clear search query"
                        cllSuffix>
                    <cll-icon>clear</cll-icon>
                </button>
            }
        </cll-form-field>
    </div>
</div>
<div class="stats-table-container">
    <table class="cll-table stats-table">
        <thead class="sticky-table-top">
        <tr>
            <th>Reference</th>
            <th>Region</th>
            <th>Zone</th>
            <th>Priority</th>
            <th>Postcode</th>
            <th>Publish date</th>
        </tr>
        </thead>
        <tbody>
            @for (_package of (filteredPackages$ | async); track _package.id) {
                <tr class="stats-row" (click)="openPackageInNewTab(_package.id)">
                    <td>{{ _package.reference }}</td>
                    <td class="nowrap">
                        {{ _package.region_name || '-' }}
                    </td>
                    <td class="nowrap">
                        {{ _package.zone_name || '-' }}
                    </td>
                    <td class="nowrap">
                        {{ _package.priority_name || '-' }}
                    </td>
                    <td class="nowrap">{{ _package.post_code || '-' }}</td>
                    <td>
                        @if (_package.publish === 'draft') {
                            Draft
                        } @else if (_package.publish === 'immediately') {
                            @if (_package.publish_at !== null) {
                                {{ _package.publish_at | appDate: 'dd/MM/yyyy HH:mm' }}
                            } @else {
                                {{ _package.created_at | appDate: 'dd/MM/yyyy HH:mm' }}
                            }
                        } @else {
                            {{ _package.publish_at | appDate: 'dd/MM/yyyy HH:mm' }}
                        }
                    </td>
                </tr>
            }
        </tbody>
    </table>
</div>
